import { render, staticRenderFns } from "./AdminArchivedProjects.vue?vue&type=template&id=6a446132&scoped=true&"
import script from "./AdminArchivedProjects.vue?vue&type=script&lang=js&"
export * from "./AdminArchivedProjects.vue?vue&type=script&lang=js&"
import style0 from "./AdminArchivedProjects.vue?vue&type=style&index=0&id=6a446132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a446132",
  null
  
)

export default component.exports